<template>
  <div class="rounded-lg border border-slate-600/70 bg-slate-900/35 p-3 space-y-2">
    <div class="flex items-center justify-between gap-3">
      <p class="text-sm font-medium text-slate-200">API e endpoints</p>
    </div>
    <div class="flex items-center gap-2">
      <select
        :value="selectedId ?? ''"
        class="w-full px-3 py-2 rounded-lg border border-slate-500/80 bg-slate-800/55 text-slate-100 text-sm focus:outline-none focus:ring-2 focus:ring-cyan-400/40 focus:border-cyan-400/70"
        @change="onChange"
      >
        <option value="">{{ single ? 'Selecione o endpoint' : 'Selecione um endpoint' }}</option>
        <option
          v-for="opt in options"
          :key="opt.id"
          :value="opt.id"
          class="bg-slate-900"
        >
          {{ opt.label }}
        </option>
      </select>
      <button
        v-if="!single"
        type="button"
        class="whitespace-nowrap text-xs px-2 py-2 rounded border border-cyan-400/40 text-cyan-200 hover:bg-cyan-400/10"
        @click="$emit('add')"
      >
        + Endpoint
      </button>
    </div>
    <div class="flex flex-wrap gap-2">
      <span
        v-for="id in selectedIds"
        :key="`api-${id}`"
        class="inline-flex items-center gap-2 px-2 py-1 rounded border border-cyan-400/30 bg-cyan-400/10 text-cyan-100 text-xs"
      >
        {{ optionLabelById(options, id) || `Endpoint #${id}` }}
        <button type="button" class="text-cyan-200 hover:text-white" @click="$emit('remove', id)">×</button>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AgentConnectorEndpoints',
  props: {
    options: { type: Array, default: () => [] },
    selectedId: { type: [Number, null], default: null },
    selectedIds: { type: Array, default: () => [] },
    single: { type: Boolean, default: false }
  },
  emits: ['update:selectedId', 'add', 'remove'],
  methods: {
    optionLabelById(options, id) {
      return (options || []).find((o) => o.id === id)?.label || null
    },
    onChange(e) {
      const raw = e?.target?.value
      const parsed = raw === '' ? null : Number(raw)
      const id = Number.isNaN(parsed) ? null : parsed
      this.$emit('update:selectedId', id)
      if (this.single) {
        this.$nextTick(() => this.$emit('add'))
      }
    }
  }
}
</script>
